"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mealConfigApi = require("@/api/mealConfigApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JoyShareConfig',
  data: function data() {
    return {
      form: {
        id: null,
        merchantPrefix: '',
        appKey: '',
        appSecret: '',
        supplier: '',
        callbackUrl: '',
        hotCities: '',
        timeoutMinutes: '',
        timeoutNotifyMethod: 'robot',
        receivers: '',
        messageTemplate: ''
      },
      loading: false,
      submitting: false,
      originalForm: {}
    };
  },
  created: function created() {
    this.initForm(); // 先初始化表单默认值
    this.fetchJoyShareConfig();
  },
  methods: {
    // 初始化表单默认值
    initForm: function initForm() {
      this.form = {
        id: null,
        merchantPrefix: '',
        appKey: '',
        appSecret: '',
        supplier: '',
        callbackUrl: '',
        hotCities: '',
        timeoutMinutes: '',
        timeoutNotifyMethod: 'robot',
        receivers: '',
        messageTemplate: ''
      };
      this.originalForm = JSON.parse(JSON.stringify(this.form));
    },
    fetchJoyShareConfig: function fetchJoyShareConfig() {
      var _this = this;
      this.loading = true;
      (0, _mealConfigApi.getJoyShareConfig)().then(function (res) {
        try {
          // 由于前端过滤器，res直接就是data数据
          if (res && _typeof(res) === 'object' && !Array.isArray(res)) {
            // 遍历form的每个字段，确保从res中获取的值不是undefined
            var newForm = _objectSpread({}, _this.form);
            Object.keys(_this.form).forEach(function (key) {
              if (res[key] !== undefined) {
                newForm[key] = res[key];
              }
            });
            _this.form = newForm;
            _this.originalForm = JSON.parse(JSON.stringify(_this.form));
          }
        } catch (error) {
          console.error('处理乐享汇供应商配置数据出错:', error);
        }
      }).catch(function (err) {
        console.error('获取乐享汇供应商配置失败:', err);
      }).finally(function () {
        _this.loading = false;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return false;
        }
        _this2.submitting = true;
        (0, _mealConfigApi.saveJoyShareConfig)(_this2.form).then(function () {
          _this2.$message({
            message: '保存成功',
            type: 'success'
          });
          _this2.fetchJoyShareConfig(); // 重新加载数据
        }).catch(function (err) {
          console.error('保存乐享汇供应商配置失败:', err);
          _this2.$message.error('保存失败：' + (err && err.message ? err.message : '未知错误'));
        }).finally(function () {
          _this2.submitting = false;
        });
      });
    },
    resetForm: function resetForm() {
      this.form = JSON.parse(JSON.stringify(this.originalForm));
      this.$refs.form.clearValidate();
    }
  }
};